import { useEffect, useMemo } from "react";
import type { CommunitySwitcher } from "../types/CommunitySwitcher";

export const useNotificationCountSync = (
  sortedCommunities: CommunitySwitcher[],
  draggableItems: CommunitySwitcher[],
  pinnedCurrentCommunity: CommunitySwitcher | null,
  isModalOpen: boolean,
  setCommunitiesNeedingCounts:
    | ((communities: CommunitySwitcher[]) => void)
    | undefined,
) => {
  const communitiesForNotifications = useMemo(() => {
    const byId = new Map(sortedCommunities.map(c => [c.id, c]));
    const ids = new Set<number>();
    draggableItems.forEach(c => ids.add(c.id));
    if (pinnedCurrentCommunity) {
      ids.add(pinnedCurrentCommunity.id);
    }
    if (isModalOpen) {
      sortedCommunities.forEach(c => ids.add(c.id));
    }
    return Array.from(ids)
      .map(id => byId.get(id))
      .filter((c): c is CommunitySwitcher => c != null);
  }, [draggableItems, pinnedCurrentCommunity, sortedCommunities, isModalOpen]);

  useEffect(() => {
    setCommunitiesNeedingCounts?.(communitiesForNotifications);
  }, [communitiesForNotifications, setCommunitiesNeedingCounts]);
};
